import React, { useState } from "react";
import { GridTable } from "cvmgmt-cube-grid-table";
import JustificationDialog from "../../Modals/JustificationDialog";
import { getEnv } from "../../../Constants/env";
import { useSelector } from "react-redux";
import { useIdToken } from "../../../hooks/useAuthSession";

const ArchivedApprovalRequests: React.FC = () => {
  const idToken = useIdToken();
  const { env } = useSelector((state: any) => state?.createApplication);
  const [groupModalData, setGroupModalData] = useState<{
    isOpen: boolean;
    data: any;
  }>({
    isOpen: false,
    data: {},
  });
  const payload = {
    sortingFilter: {
      filter: [],
      page: {
        limit: 10,
        offset: 0,
      },
    },
  };
  const datatableConfig = {
    url: `${getEnv()?.baseURL}/request/denied/myapproval?env=${env}`,
    data: payload,
    headers: {
      "Content-Type": "application/json",
      Authorization: idToken || "",
      "x-api-key": "sasa",
    },
  };
  return (
    <>
      {idToken && (
        <GridTable
          style={{
            height: "calc(100vh - 30.5rem)",
            fontFamily: "ToyotaType-Regular",
          }}
          customPayload={true}
          sorting={[{ id: "created_dt", desc: false }]}
          apiConfig={datatableConfig}
          title={"Access Status"}
          isCustomizeColumns={false}
          onRowClick={(_event: any, row: any) => {
            const dataRow = row?.original;
            setGroupModalData({
              isOpen: true,
              data: dataRow,
            });
          }}
          showLoader={false}
        />
      )}
      {groupModalData?.isOpen && (
        <JustificationDialog
          open={groupModalData?.isOpen}
          onClose={() =>
            setGroupModalData({
              isOpen: false,
              data: {},
            })
          }
          row={groupModalData?.data?.feature_permission_justification}
        />
      )}
    </>
  );
};

export default ArchivedApprovalRequests;
